import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router} from '@angular/router';
import {skipUntil} from 'rxjs';
import {map} from 'rxjs/operators';
import {AuthenticationService} from '../service';

import {ConfirmInvitationFacadeService} from './store/confirm-invitation-facade.service';

export const canActivate: CanActivateFn = (route: ActivatedRouteSnapshot) => {
    const facadeService = inject(ConfirmInvitationFacadeService);
    const authService = inject(AuthenticationService);

    const router = inject(Router);
    const url = route.queryParams['url'];

    if (url == null || url.trim() === '') {
        return router.navigate(['/']);
    }

    if(authService.isLoggedIn()){
        //TODO: Logout functionality seems to be part of some service responsibility. We might need to refactor it.
        // remove user from local storage to log user out
        authService.logout();
    }
    facadeService.checkConfirmationUrl(url);

    return facadeService.checkInvitationUrl$.pipe(
        skipUntil(facadeService.checkInvitationUrlLoading$),
        map(x => x?.trim() != '')
    )
}